module.exports = __webpack_public_path__ + "static/media/dog4.403af1df.jpg";